<template>
  <div class="buyProduct-content">
    <div class="buyProduct">
      <div class="basic-information-title">维修记录</div>
    </div>
      <div class="product-list"  v-if="list.length>0">
      <div v-for="(item,index) in list" v-bind:key="index">
        <div class="flex product-list-header">
          <div class="flex center">
            <img class="camera" :src="require('@/assets/img/camera.png')" alt>
            <div class="product-name">服务单类型：{{item.U_ServiceTktType||''}}</div>
          </div>
        </div>
        <div class="product-list-content">

          <div class="basic-information-flex"  v-bind:class="item.edit==true?'active':'activeno'">
            <ul class="basic-information-lists">
              <li>
                <div class="basic-information-lists-item">维修日期</div>
                <div class="basic-information-lists-text">{{item.U_RealCompletDate||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">产品货号</div>
                <div class="basic-information-lists-text">{{item.U_Code||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">产品大类</div>
                <div class="basic-information-lists-text">{{item.U_ProductType || ""}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">产品分类</div>
                <div class="basic-information-lists-text">{{item.U_LeicaProductType || ""}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">产品名称</div>
                <div class="basic-information-lists-text">{{item.U_ProductNameCN || ""}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">产品英文名</div>
                <div class="basic-information-lists-text">{{item.U_ProductNameEN||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">序列号</div>
                <div class="basic-information-lists-text">{{item.U_Serial || ''}}</div>
              </li>
              <!--<li>
                <div class="basic-information-lists-item">保修到期日</div>
                <div class="basic-information-lists-text">{{item.U_ExpirationDate || ''}}</div>
              </li>-->
              <li>
                <div class="basic-information-lists-item">报修内容</div>
                <div class="basic-information-lists-text">{{item.U_RepairContent || ''}}</div>
              </li>              
              <li>
                <div class="basic-information-lists-item">检测结果</div>
                <div class="basic-information-lists-text">{{item.U_CheckResult || ''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">服务状态</div>
                <div class="basic-information-lists-text">{{item.stateName || ''}}</div>
              </li>
            </ul>
          </div>
        </div>

        <!-- 收起 -->
        <div class="flex packUp center" @click="packUp(index)">
          <img
            :src="require('@/assets/img/upArrow1.png')"
            v-if="item.edit==true"
            class="arrow"
            alt
            srcset
          >
          <img
            :src="require('@/assets/img/dowmArrow.png')"
            v-if="item.edit==false"
            class="arrow"
            alt
            srcset
          >
          {{item.edit==true?"收起详情":"展开详情"}}
        </div>
      </div>
    </div>
  </div>
</template>


<script>


export default {
  name: "",
  data() {
    return {
        list: [],
        custId:"",               //客户ID
    };
  },
  methods: {
    /**
     * 查询维修记录列表
     */
    queryList(custId){
        this.custId=custId;
        this.$api.get("api/cust/queryRepairHis",{
          salesId:this.$wxuserUtil.getUserId(),
          custId:custId
        }).then(res => {
          if(res.success==true){
            if(res.data.length>0){
              for(let i=0;i<res.data.length;i++){
                res.data[i]['edit']=false;
                res.data[i]['height']='auto';
              }
              this.list=res.data;
            }}
        });
    },

    /**
     *
     *  收起 打开
     *  @param {Bealoon}  val
     *  @param {Number}   index
     */
    packUp(index) {
      let $list = [];
      $list = this.list;
      if ($list[index]["edit"] == true) {
        $list[index]['edit']=false
        this.list=$list;
      }else
      if ($list[index]["edit"] == false) {
         $list[index]['edit']=true
        this.list=$list;
      }
    }
  },
  mounted() {

  },
  created() {}
};
</script>



<style lang="less" scoped>
.buyProduct-content{
.product-model {
  .van-popup {
    width: 9rem;
    height: 14.5rem;
    border-radius: 0.3rem;
    .model-height{
      height:13.1rem;
      overflow-y: auto;
    }

    // 确定取消
    .confirm-cancel {
      width: 100%;
      height: 1.4rem;
      border-top: 1px solid #b3b8c3;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 0rem;
      .button-flex-color {
        width: 50%;
        height: 1.4rem;
        text-align: center;
        .button-flex-item {
          width: 100%;
          height: 100%;
          text-align: center;
          line-height: 1.3rem;
          font-size: 0.4rem;
          background: #222222;
          color: #fff;
        }
        .button-active {
          background: #e51c23;
          color: #fff;
        }
      }
      .flex-border-button {
        // border-right: 1px solid #a4abba;
      }
    }

    input{
      border:none;
      outline: none;
      width:100%;
      background: #ffffff;
    }

    .product-title {
      height: 1.5rem;
      line-height: 1.5rem;
      text-align: center;
      font-weight: bold;
      color: #252424;
    }
    .basic-models-list {
      height: 95%;
      font-size: 0.35rem;
      // overflow-x: auto;
      width: 95%;
      margin: 0 auto;
      .basic-models-list-item,
      .basic-models-list-itemS {
        margin-left: 0.8rem;
        height: 1.2rem;
        -ms-flex-item-align: center;
        align-items: center;
        display: flex;
        flex-direction: row;
        // justify-content: space-between;
        position: relative;
      }
      .selectUp {
        border: 0;
        margin: 0;
        padding: 0;
        width: 100%;
        resize: none;
        display: block;
        color: #323233;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        background-color: transparent;
        .uparrow {
          position: absolute;
          right: 0.2rem;
          top: 50%;
          width: 0.3rem;
          height: 0.3rem;
          margin-top: -0.15rem;
        }
        input {
          border: none;
          outline: none;
        }
        textarea {
          border: none;
          outline: none;
          height: 0.8rem;
          width: 4rem;
        }
      }
    }
    .basic-models-list-item:after {
      content: "  ";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background-color: #b3b8c3;
      /* 如果不用 background-color, 使用 border-top:1px solid #f00; 效果是一样的*/
      -webkit-transform: scaleY(0.15);
      transform: scaleY(0.15);
    }
    .van-cell {
      padding: 0rem;
    }
    .models-list-item-title {
      width: 5rem;
    }
    .region {
      width: 3rem;
      position: relative;
      height: 1.2rem;
      line-height: 1.2rem;
      -ms-flex-item-align: center;
      align-items: center;
      padding-left: 0.1rem;
      // border-right: 1px  solid  #b3b8c3;
      .uparrow {
        position: absolute;
        right: 0.5rem;
        top: 50%;
        width: 0.3rem;
        height: 0.3rem;
        margin-top: -0.15rem;
      }
    }
  }
}
.newlyAddImg {
  width: 0.5rem;
  height: 0.5rem;
}
.product-list-content{
    .basic-information-flex {
    padding: 0.3rem 0.5rem;
    overflow: hidden;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -o-transition: all 0.5s;
    -ms-transition: all 0.5s;
    }
    .active {
      height: auto!important;

    }
    .activeno {
      height: 3.1rem!important;
    }
    }
.product-list {
  margin: 0.3rem 0.5rem 0.3rem 0.5rem;
  // background: #F2F2F2;
  min-height: 1rem;
  .basic-information-flex {
    padding: 0.3rem 0.5rem;
    overflow: hidden;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -o-transition: all 0.5s;
    -ms-transition: all 0.5s;
    .basic-information-lists {
      li {
        display: flex;
        //    justify-content: space-between;
        -ms-flex-item-align: center;
        align-items: center;
        height: 0.8rem;
        line-height: 0.8rem;
      }
      .basic-information-lists-item {
        width: 2.5rem;
        color: #7e7e7e;
        font-size: 0.35rem;
      }
      .basic-information-lists-text {
        font-size: 0.35rem;
        color: #4d4d4d;
      }
    }
  }
  .product-list-content {
    background: #f2f2f2;
  }
  .packUp {
    padding: 0rem 0.3rem;
    background: #f2f2f2;
    margin-top: 0.05rem;
    margin-bottom: 0.3rem;
    height: 1rem;
    line-height: 1rem;
  }
  .arrow {
    width: 0.4rem;
    height: 0.4rem;
  }
  .product-list-header {
    height: 1rem;
    -ms-flex-item-align: center;
    align-items: center;
    padding: 0rem 0.3rem;
    flex-direction: row;
    justify-content: space-between;
    background: #f2f2f2;
    .product-name {
      color: #2a2a2a;
      font-size: 0.4rem;
      padding-left: 0.3rem;
    }
  }
  .camera,
  .redactImg {
    width: 0.4rem;
    height: 0.4rem;
  }
}
.buyProduct {
  // width:100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  -ms-flex-item-align: center;
  align-items: center;
  height: 1rem;
  padding: 0.3rem 0.5rem 0rem 0.5rem;
  border-top: 0.1rem solid rgb(244, 244, 244);
  .redactImg {
    width: 0.4rem;
    height: 0.4rem;
  }
  .basic-information-title {
    position: relative;
    color: #2a2a2a;
    font-size: 0.4rem;
    font-weight: 600;
  }
  .basic-information-title::after {
    content: "";
    width: 0.1rem;
    height: 0.35rem;
    position: absolute;
    left: -0.2rem;
    top: 0.12rem;
    background-color: #e10913;
  }
}
}
</style>




// WEBPACK FOOTER //
// src/components/client/childCompoents/repairHis.vue